import React, { FC } from 'react';
import cx from 'classnames';
import styles from './ItemContainer.module.scss';
import { ItemIcon } from './ItemIcon';
import { ContentImageEntry } from 'api/contentful/contentTypes.cloverdotcom';

interface IItemContainerProps {
  itemKey?: string;
  isBusinessOfferingStep: boolean;
  isAddButtonShown: boolean;
  isSelected: boolean;
  handleClick: () => void;
  addItemIcon?: ContentImageEntry;
  selectedItemCustomIcon?: ContentImageEntry;
  children?: React.ReactNode;
  ariaLabel?: string;
}

export const ItemContainer: FC<IItemContainerProps> = ({
  itemKey,
  isBusinessOfferingStep,
  isAddButtonShown,
  isSelected,
  handleClick,
  children,
  addItemIcon,
  selectedItemCustomIcon,
  ariaLabel,
}) => {
  if (isBusinessOfferingStep) {
    return (
      <div
        className={cx(styles.byoItemContainer, {
          [styles.byoItemContainerFirstStep]: !isAddButtonShown,
          [styles.itemSelected]: isSelected,
        })}
      >
        <button
          className={styles.button}
          onClick={handleClick}
          data-heap-item={itemKey}
          aria-label={ariaLabel}
        >
          <ItemIcon icon={isSelected ? selectedItemCustomIcon : addItemIcon} />
        </button>
        {children}
      </div>
    );
  }

  return (
    <div
      className={cx(styles.byoItemContainer, {
        [styles.byoItemContainerFirstStep]: !isAddButtonShown,
        [styles.itemSelected]: isSelected,
      })}
    >
      {children}
    </div>
  );
};
